

export class VueOtherDocumentListScreenData {
    
    availableFilters: Object;
    user_id: number;
    totalItems: number;
    loading_odocs: boolean;
    other_documents: Array<any>;
    other_documents_headers: Array<any>;
    selectedItems: Array<any>;
    documentName: string;
    limit: number;
    offset: number;
    currentPage: number;
    search: string;
    loadingItems: boolean;
    selectAllItems: boolean;
    tableHeight: string;
    initNumItemsPerPage: number;
    sortBy: string;
    footerItemsPerPageText: string;
    footerItemsPerPageOptions: Array<number>;
    showSelect: boolean;
    textNoResults: string;
    textLoading: string;
    itemKey: string;
    hideHeaderCheckbox: boolean;
    mobile: boolean;
    showDeletePupup: boolean;
    msgDeletePupup: string;
    resolvePopupPromise: any;
    loading_d_other_doc: boolean;
    drawer: boolean;
    filter_doc_name: string;
    filter_doc_type: any;
    filter_date_from: any;
    filter_date_to: any;
    action_menu: boolean;
    asyncJobState: string;
    asyncJobId: number;
    filter_need_approval: boolean;
    action: string;
    dialogChangeWorkflow: boolean;
    workflowOptions: Array<any>;
    selectedWorkflow: any;
    cascadeEntities: boolean;
    companyFolders: Array<any>;
    popUpSelectFolder: boolean;
    resolveSelectedFolderPromise: any;
    currentFolderRoute: string;
    currentFolderUUID: string;
    popUpCreateFolder: boolean;
    newFolderName: string;

    constructor(){
        this.companyFolders = [];
        this.availableFilters = {
            original_file_name: {
                'name': 'original_file_name',
                'label': 'Nombre',
                'value': '',
                'type': 'text',
                'icon': 'mdi-file-document',
            },
            type: {
                'name': 'type',
                'label': 'Tipo',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'otros', text: 'Otros'}
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-chart',
                'text':''
            },
            date_from: {
                'name': 'date_from',
                'label': 'Fecha desde',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            date_to: {
                'name': 'date_to',
                'label': 'Fecha hasta',
                'value': '',
                'type': 'date',
                'icon': 'mdi-calendar',
            },
            need_approval: {
                'name': 'need_approval',
                'label': 'Pendiente de mi aprobación',
                'user_values': [
                    { value: '', text: 'Todos'},
                    { value: 'yes', text: 'Sí'},
                    { value: 'no', text: 'No'},
                ],
                'multiple': false,
                'value': '',
                'type': 'select',
                'icon': 'mdi-file-chart',
                'text':''
            },
        },
        this.popUpSelectFolder = false;
        this.resolveSelectedFolderPromise = undefined;
        this.cascadeEntities = false;
        this.user_id = undefined;
        this.totalItems = 0;
        this.loading_odocs = false;
        this.other_documents = [];
        this.other_documents_headers =  [
            {
                text: 'Id',
                sortable: true,
                value: 'id'
            },
            {
                text: 'Nombre del documento',
                sortable: true,
                value:'original_file_name'
            },
            {
                text: 'Tipo de documento',
                sortable: true,
                value: 'type'
            },
            {
                text: 'Fecha de subida',
                sortable: true,
                value: 'created'
            },
            {
                text: 'Workflow',
                sortable: false,
                value: 'workflow_name'
            },
            {
                text: 'Estado',
                sortable: false, 
                value: 'state'
            }
        ];
        this.selectedItems = [];
        this.documentName = '';
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
        this.search = '';
        this.loadingItems = false;
        this.selectAllItems = false;
        this.tableHeight = '59vh';
        this.initNumItemsPerPage = 0;
        this.sortBy = '';
        this.footerItemsPerPageText = 'Documentos por página:';
        this.footerItemsPerPageOptions = [5, 10, 50, 100];
        this.showSelect = false;
        this.textNoResults = 'No se han encontrado documentos';
        this.textLoading = 'Cargando...';
        this.itemKey = 'id';
        this.hideHeaderCheckbox = false;
        this.mobile = false;
        this.showDeletePupup = false;
        this.msgDeletePupup = 'Se van a borrar los documentos seleccionados.';
        this.resolvePopupPromise = undefined;
        this.loading_d_other_doc = false;
        this.drawer = false;
        this.filter_doc_name = '';
        this.filter_doc_type = undefined;
        this.filter_date_from = undefined;
        this.filter_date_to = undefined;
        this.action_menu = false;
        this.asyncJobState = 'done';
        this.asyncJobId = 0;
        this.filter_need_approval = false;
        this.action = '';
        this.dialogChangeWorkflow = false;
        this.workflowOptions = [{'name':'Sin workflow', 'id':0}];
        this.selectedWorkflow = undefined;
        this.popUpCreateFolder = false;
        this.newFolderName = '';
    }
    
}